import { useParams, useNavigate } from "react-router-dom";
import "../../../assets/styles/irprint.css";
import { PRINT_TEXT } from "@utils/constants/print.constants";
import logo from "../../../assets/images/print_logo.png";
import { useEffect } from "react";
import { useGetStockTransferPrintQuery } from "@states/warehouse-and-inventory/stock-transfer.api";

const StockTransferPrintPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: stockTransferData,
    isLoading: stockTransferLoading,
    error: stockTransferError,
  } = useGetStockTransferPrintQuery({
    id: id!,
  });

  console.log("stockTransferData", stockTransferData);

  useEffect(() => {
    if (!stockTransferLoading && stockTransferData) {
      const timeout = setTimeout(() => {
        window.print();
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [stockTransferLoading, stockTransferData]);

  if (stockTransferLoading)
    return <div className="text-center p-8">Loading...</div>;
  if (stockTransferError)
    return (
      <div className="text-center p-8 text-red-500">Error loading data</div>
    );

  return (
    <div className="print-page">
      <div className="print-container">
        <div className="flex items-center gap-4 mb-4">
          <div className="logo-container ml-10 mb-5 w-40 h-30">
            <img
              src={logo}
              alt="Company Logo"
              className="w-full h-full object-contain"
            />
          </div>
          {/* Header */}
          <div className="header grn-header text-center mb-0">
            <h1 className="company-name text-xl font-bold">
              {PRINT_TEXT.companyName}
            </h1>
            <h2 className="document-title text-lg font-semibold">
              Stock Transfer Note
            </h2>
          </div>
        </div>

        <div className="border-b border-black flex-1 w-full"></div>

        {/* Document Info */}
        <div>
          <div className="grid grid-cols-12  gap-x-4 gap-y-4 w-full my-4">
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold min-w-40">
                သို့ (အမည်/လိပ်စာ)
              </span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.to_warehouse.warehouse_name || ""}
                <br />
                {stockTransferData?.data?.to_warehouse.warehouse_address || ""}
              </span>
            </div>
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold w-40">လက်ခံသူ</span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.from_warehouse.warehouse_name || ""}
                <br />
                {stockTransferData?.data?.from_warehouse.warehouse_address ||
                  ""}
              </span>
            </div>
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold w-40">
                ကုန်ပို့သည့်အကြောင်း
              </span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.reference_id || ""}
              </span>
            </div>
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold w-40">အမှတ်စဥ်</span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.inventory_transfer_code}
              </span>
            </div>
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold w-40">ကားနံပါတ်</span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.goods_return_note_code || "-"}
              </span>
            </div>
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold w-40">ရက်စွဲ</span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.return_date || ""}
              </span>
            </div>
            <div className="col-span-6 flex justify-end">
              <span className="label font-semibold w-40">
                ကုန်ပစ္စည်းရောက်မည့်နေ့
              </span>
              <span>:</span>
              <span className="value border-b border-black flex-1">
                {stockTransferData?.data?.customer?.customer_first_name || ""}
              </span>
            </div>
          </div>
        </div>

        {/* Items Table */}
        <table className="table-auto border-collapse border  w-full text-sm">
          <thead className="text-center font-bold">
            <tr>
              <th className="border  px-2 py-1">Sr. No.</th>
              <th className="border  px-2 py-1 bg-blue-100">Code No</th>
              <th className="border  px-2 py-1">Item Description</th>
              <th className="border  px-2 py-1">Unit</th>
              <th className="border  px-2 py-1">Qty</th>
              <th className="border  px-2 py-1">Total Weight (Viss)</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {stockTransferData?.data?.product_detail?.map(
              (item: any, index: number) => (
                <tr key={item.product_code}>
                  <td className="border  px-2 py-1">{index + 1}</td>
                  <td className="border  px-2 py-1">{item?.product_name}</td>
                  <td className="border  px-2 py-1">
                    {item?.product_description}
                  </td>
                  <td className="border  px-2 py-1">{item?.unit_name}</td>
                  <td className="border  px-2 py-1">{item?.qty}</td>
                  <td className="border  px-2 py-1"></td>
                </tr>
              )
            )}
          </tbody>
        </table>

        <div className="flex justify-between mt-10 space-x-10">
          <div className="flex flex-col items-start space-y-4">
            <div className="text-center w-full font-semibold">Received by</div>
            <div>
              <div className="flex flex-col">
                <label className="mb-1">Sign</label>
                <div className="border-t border-black w-48"></div>
              </div>
              <div className="mt-4 flex flex-col">
                <label className="mb-1">Name</label>
                <div className="border-t border-black w-48"></div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start space-y-4">
            <div className="text-center w-full font-semibold">Delivery</div>
            <div>
              <div className="flex flex-col">
                <label className="mb-1">Sign</label>
                <div className="border-t border-black w-48"></div>
              </div>
              <div className="mt-4 flex flex-col">
                <label className="mb-1">Name</label>
                <div className="border-t border-black w-48"></div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start space-y-4">
            <div className="text-center w-full font-semibold">Issued by</div>
            <div>
              <div className="flex flex-col">
                <label className="mb-1">Sign</label>
                <div className="border-t border-black w-48"></div>
              </div>
              <div className="mt-4 flex flex-col">
                <label className="mb-1">Name</label>
                <div className="border-t border-black w-48"></div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start space-y-4">
            <div className="text-center w-full font-semibold">
              Authorized by
            </div>
            <div>
              <div className="flex flex-col">
                <label className="mb-1">Sign</label>
                <div className="border-t border-black w-48"></div>
              </div>
              <div className="mt-4 flex flex-col">
                <label className="mb-1">Name</label>
                <div className="border-t border-black w-48"></div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-span-3">
          <p className="text-left italic">{PRINT_TEXT.receivedCondition}</p>
        </div> */}

        {/* <div className="signatures grid grid-cols-3 gap-4 mt-6">
          <div className="signature-col text-center">
            <p className="font-semibold mb-2">Sender</p>
            <div className="border-b border-black mb-2"></div>
            <div className="signature-line relative h-8 mb-4">
              <span className="absolute left-0">Sign :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
            <div className="signature-line relative h-8 mb-4">
              <span className="absolute left-0">Name :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
            <div className="signature-line relative h-8">
              <span className="absolute left-0">Position :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
          </div>

          <div className="signature-col text-center">
            <p className="font-semibold mb-2">Inspector</p>
            <div className="border-b border-black flex-1 mb-2"></div>
            <div className="signature-line relative h-8 mb-4">
              <span className="absolute left-0">Sign :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
            <div className="signature-line relative h-8 mb-4">
              <span className="absolute left-0">Name :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
            <div className="signature-line relative h-8">
              <span className="absolute left-0">Position :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
          </div>

          <div className="signature-col text-center">
            <p className="font-semibold mb-2">Receiver</p>
            <div className="border-b border-black mb-2 w-30"></div>
            <div className="signature-line relative h-8 mb-4">
              <span className="absolute left-0">Sign :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
            <div className="signature-line relative h-8 mb-4">
              <span className="absolute left-0">Name :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
            <div className="signature-line relative h-8">
              <span className="absolute left-0">Position :</span>
              <div className="border-dotted border-b-2 border-black ml-12 h-6"></div>
            </div>
          </div>

          <div className="col-span-3 text-left mt-4">
            <p className="text-sm absolute left-0">FORM: 0/1 READ</p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default StockTransferPrintPage;
